import React, { useRef, useState } from 'react';
import { Loader2, Upload } from 'lucide-react';
import { toast } from 'sonner';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { clientPortalAPI, isClientViewMode } from '../lib/api';

const ACCEPT = '.pdf,.jpg,.jpeg,.png,.gif,.webp,.heic,.heif,.mp4,.mov,.avi,.webm,.m4v,.doc,.docx,.odt,.rtf,.txt,.xls,.xlsx,.ods,.csv,.zip';

// El cliente nos sube archivos: solo los ve él y el equipo de Karma
export default function ClientDocUpload({ onUploaded }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setBusy(true);
    try {
      await clientPortalAPI.uploadMyDocument(file);
      toast.success('Archivo enviado. ¡Gracias!');
      onUploaded?.();
    } catch (err) { toast.error(err.message); } finally { setBusy(false); }
  };
  return (
    <Card className="border-dashed" data-testid="client-doc-upload-card">
      <CardContent className="p-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-sm font-medium">Envíanos un archivo</p>
          <p className="text-xs text-muted-foreground">PDF, imágenes, vídeo, documentos de texto, hojas de cálculo o ZIP (máx. 25 MB). Solo lo veréis tú y nuestro equipo.</p>
        </div>
        <input ref={ref} type="file" accept={ACCEPT} className="hidden" onChange={pick} data-testid="client-doc-upload-input" />
        <Button onClick={() => ref.current?.click()} disabled={busy || isClientViewMode()} data-testid="client-doc-upload-btn">
          {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Upload className="w-4 h-4 mr-2" />}Subir archivo
        </Button>
      </CardContent>
    </Card>
  );
}
